import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export class ErrorModalDetails {
  constructor(
    public title: string,
    public message: string,
    public timeout: number = 0,
    public hasToLogout: boolean = false,
    public cancellable: boolean = true
  ) {}
}

@Injectable({
  providedIn: 'root'
})
export class ErrorModalService {

  error = new Subject<ErrorModalDetails>()

  display(error: ErrorModalDetails){
    this.error.next(error)
  }
}
